import { render, staticRenderFns } from "./VersionControlTable.vue?vue&type=template&id=30e1a742&scoped=true&"
import script from "./VersionControlTable.vue?vue&type=script&lang=js&"
export * from "./VersionControlTable.vue?vue&type=script&lang=js&"
import style0 from "./VersionControlTable.vue?vue&type=style&index=0&id=30e1a742&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e1a742",
  null
  
)

export default component.exports